import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { TopupServiceService } from '../Services/topup-service.service';
import { CookieService } from '../Services/cookie';
import { AccountService } from '../Services/account.service';

@Component({
  selector: "app-quick-payment",
  templateUrl: "./quick-payment.component.html",
  standalone:false,
  styleUrls: ["./quick-payment.component.scss"],
})
export class QuickPaymentComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  selectedType: string = "";
  Typelist;
  idnumber: number = undefined;
  CardDigit: number;
  Accountno: number;
  amount: number;
  selectedMethod: string = "";
  selectedamounttype: string = "";
  Methodlist;
  mobileno;
  CardDetail;
  LoanDetail;
  inquirypay: boolean = false;
  amountdetail;

  constructor(
    private cookieService: CookieService,
    private _router: Router,
    private location: Location,
    private auth: AuthService,
    private commonP: CommonService,
    private topup: TopupServiceService,
    private account: AccountService
  ) {}


  back() {
    this.location.back();
  }

  ngOnInit(): void {

  }


 

  showModal(num) {
    this.modalObservable.next(num);
  }
  
 
  

  typeOfPay() {


    this.cookieService.set("flow", 'Quickpay',true);
    // this.cookieService.set("IdNumber", this.idnumber.toString(), false,undefined,undefined,undefined,undefined,true,"Strict");
       this.cookieService.set("CVa21f11",this.idnumber.toString(),true);

    this._router.navigateByUrl("/TypeOfPay");
  }
  MobileNumber() {

 
    this.cookieService.set("page", 'Quickpay',true);

    this._router.navigateByUrl("/TypeOfPay");

   // this._router.navigateByUrl("/MobileNumber");
  }
  Valid(){

    if(this.idnumber != undefined){
      if(this.idnumber.toString().length < 8){
        return true;
        
      }
      else{
        return false
      }
    }
    else{
      return true
    }
  }
}

